import {WinterHoardGameAssets} from "../../WinterHoardGameAssets";
import {BulgePinchFilter, TwistFilter} from 'pixi-filters';
import {Container, Sprite} from "pixi.js";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import { Reels } from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";



/**
 * Class description
 *
 * Created: 2019-08-22
 * @author jonas
 */
export class MysterySymbol extends Container {
    private _revealedSymbol:string;


    get symbolPosition():[number, number] {
        return this._symbolPosition;
    }

    private _baseSprite:Sprite;
    private _whiteSprite:Sprite;
    private _twistFilter:TwistFilter;
    private _bulgeFilter:BulgePinchFilter;
    private _glowSprite:Sprite;
    private _symbolPosition:[number, number];
    private _container:PIXI.Container;
    private _idleAnimation:TimelineLite;
    private _mysteryAnimation:TimelineSprite;

    constructor(position:[number, number], container:PIXI.Container, revealedSymbol:string) {
        super();
        this._revealedSymbol = revealedSymbol;

        const pos:any = Helper.getSymbolPositions(position[0], position[1]);
        this.position.set(
            pos[0],
            pos[1]
        );

        this._symbolPosition = position;
        this._container = container;

        this._baseSprite = new Sprite(WinterHoardGameAssets.getSymbolStateTextures("M")[0]);
        this._baseSprite.anchor.set(0.5, 0.5);

        this._mysteryAnimation = new TimelineSprite(GameResources.getTextures("mysterySymbolAnim"));
        this._mysteryAnimation.anchor.set(0.5, 0.5);


        // TODO: Remove
        // this._whiteSprite = new Sprite(WinterHoardGameAssets.getSymbolStateTextures("M", "white")[0]);
        // this._whiteSprite.anchor.set(0.5, 0.5);
        // this._whiteSprite.alpha = 0.0;

        /*this._glowSprite = new Sprite(WinterHoardGameAssets.getSymbolStateTextures("M", "glow")[0]);
        this._glowSprite.anchor.set(0.5, 0.5);
        this._glowSprite.alpha = 0.0;*/

        /*this._bulgeFilter = new BulgePinchFilter();
        this._bulgeFilter.strength = 0;
        this._bulgeFilter.radius = 55;
        this._bulgeFilter.center = new PIXI.Point(0.5, 0.5);


        this._twistFilter = new TwistFilter();
        this._twistFilter.angle = 0;
        this._twistFilter.radius = 55;
        this._twistFilter.offset = new PIXI.Point();*/

        //this.filters = [this._twistFilter, this._bulgeFilter];
        // TODO ////////////////

        this.addChild(this._baseSprite);
        this.addChild(this._mysteryAnimation);
        //this.addChild(this._glowSprite);
        //this.addChild(this._whiteSprite);
        //this.scale.set(1.1, 1.1);

    }

    public update() {
        const global = this.toGlobal(new PIXI.Point());
        //this._twistFilter.offset.set(global.x, global.y);
        //this._bulgeFilter.center.set(global.x, global.y);
    }

    public showOverlay() {
        this.update();
        this._container.addChild(this);
    }

    public getRevealAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        const symbol:StateReelSymbol | null = Reels.getSymbol(this._symbolPosition[0], this._symbolPosition[1]);

        tl.add(() => {
            //this.update();
            this._container.addChild(this);
        });

        /*tl.add([
            new TweenLite(this._glowSprite, 0.4, {alpha : 1, ease : Power2.easeIn}),
        ]);*/


        if(symbol) {
            //symbol.replaceWith(this._revealedSymbol, this._symbolPosition[0]);
            //this._mysteryAnimation.setFrame(0);
            //this._mysteryAnimation.visible = true;

            tl.add(() => {
                if (symbol.symName !== "M"){
                    console.log("Not the right symbol?");
                    console.log(symbol);
                    console.log("Revealed sym: " + this._revealedSymbol);


                    //debugger;
                }
                symbol.replaceWith(this._revealedSymbol, this._symbolPosition[0]);
                symbol.setVisibility(false);
                //symbol.setVisibility(false);
            })
        }
        else {
            debugger;
            console.error("No Symbol?");
        }

        tl.add([
            () => this._baseSprite.visible = false,
            this._mysteryAnimation.getAnimationAutoShowHide(),
            //new TweenLite(this.scale, 0.5, {x : 1.3, y : 1.3, ease : Linear.easeNone}),
            //new TweenLite(this._twistFilter, 0.5, {radius : 55 * 1.3, ease : Linear.easeNone}),
        ]);
        tl.add([
            //(symbol)? () => symbol.setVisibility(true) : () => {},
            new TweenLite(this, 0.2, {alpha : 0, ease : Linear.easeNone}),
        ]);
        tl.add([
            (symbol)? () => symbol.setVisibility(true) : () => {}
            /*() => {
                const symbol:StateReelSymbol | null = Reels.getSymbol(this._symbolPosition[0], this._symbolPosition[1]);
                if(symbol) {
                    symbol.setVisibility(true);
                }
            }*/
        ], "-=0.55");
        tl.add((symbol)? () => symbol.setVisibility(true) : () => {});


        //tl.add(new TweenLite(this._twistFilter, tl.totalDuration(), {angle : -15, ease : Power1.easeIn}), 0);

        tl.add(() => {
            this._container.removeChild(this);
            if(this._idleAnimation) {
                this._idleAnimation.kill();
            }
        });

        return tl;
    }


    public getShowAnimation(animated:boolean):TimelineLite {
        const tl:TimelineLite = new TimelineLite();

        tl.add(() => {
            this._container.addChild(this);
            this.update();
        });

        if(animated) {
            this.alpha = 0;
            tl.add(new TweenLite(this, 0.5, {alpha : 1}));
        }

        tl.add(() => this.startIdleAnimation());

        return tl;
    }

    private startIdleAnimation() {
        //this._idleAnimation = new TimelineMax({repeat : -1});
        //this._idleAnimation.add(new TweenMax(this._bulgeFilter, 0.3, {strength : 0.2, ease : Power2.easeOut}));
        //this._idleAnimation.add(new TweenMax(this._bulgeFilter, 0.3, {strength : 0, ease : Power2.easeIn}));
        //this._idleAnimation.add(new TweenMax(this._bulgeFilter, 0.3, {strength : -0.4, ease : Power2.easeOut}));
        //this._idleAnimation.add(new TweenMax(this._bulgeFilter, 0.3, {strength : 0, ease : Power2.easeIn}));
    }


}